var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mx-2"},[_c('v-btn',{attrs:{"icon":"","small":""},on:{"click":function($event){_vm.fullscreen ? _vm.exitFullScreen() : _vm.fullScreen()}}},[_c('v-icon',{staticClass:"medium-icon"},[_vm._v(_vm._s(_vm.fullscreen ? 'zoom_out_map' : 'crop_free'))])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }